module.exports = __webpack_public_path__ + "media/images/restricciones-color-df2cb764df40d6cdf4209d72f6c22ad0.png";